import './AcceptButtons.scss';
import React from "react";
import {CheckCircle} from '@mui/icons-material';
import {ReviewChoice} from "../../../../services/classes/MaterializedClasses.ts";

type Props = {
    choice: ReviewChoice | null,
    onClick?: () => void
}
export const AcceptButtons: React.FC<Props> = ({choice, onClick}) => {
    return <CheckCircle
        className={
            'accept-buttons'
            + (choice === ReviewChoice.ACCEPT ? ' btn-accepted' : '')
            + (choice === ReviewChoice.REJECT ? ' btn-rejected' : '')
            + (onClick ? ' clickable' : '')
        }
        onClick={onClick}
    />
}
